import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import { addDays } from "date-fns";
import React from "react";

interface Props {
  date: Date;
  onChange: (date: Date) => void;
  className?: string;
}

export const DaySelect: React.FunctionComponent<Props> = ({ date, onChange, className }) => {
  const classes = useStyles();

  const moveDate = (offset: number) => () => {
    onChange(addDays(date, offset));
  };

  return (
    <div className={clsx(classes.container, className)}>
      <IconButton onClick={moveDate(-1)}>
        <ChevronLeft className={classes.chevron} />
      </IconButton>
      <div className={classes.selectedDay}>
        <Typography variant="overline" lineHeight={0.1}>
          {date.toLocaleString(window.navigator.language, { weekday: "long" })}
        </Typography>
        <Typography variant="h6">{date.toLocaleDateString()}</Typography>
      </div>
      <IconButton onClick={moveDate(1)}>
        <ChevronRight className={classes.chevron} />
      </IconButton>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  chevron: {
    height: "2rem",
    width: "2rem",
  },
  container: {
    display: "flex",
    alignItems: "center",
    alignContent: "space-around",
  },
  selectedDay: {
    textAlign: "center",
    padding: theme.spacing(0, 0),
  },
}));
